<template>
  <div class="custom-select-container" @click="custoSelectClickHandler">
    <select ref="select" name="select" class="custom-select" :value="value" @change="handleChange" >
      <option v-for="item in options" :key="item.value" :value="item.value" :disabled="!!item.disabled">{{ item.name }}</option>
    </select>
    <div>
      <span v-if="lang === 'en'" class="custom-select-arrow">edit</span>
      <span v-else class="custom-select-arrow custom-select-arrow-ru">выбрать</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    changeHandler: {
      type: Function,
      required: true,
    },
    lang: {
      type: String,
      default: 'en',
    },
    value: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value'],
  methods: {
    triggerSelect() {
      this.$refs.select.click();
    },
    custoSelectClickHandler() {
      const selectElement = this.$refs.select;
      selectElement.focus();

      const event = new KeyboardEvent('keydown', {
        key: 'ArrowDown',
        keyCode: 40,
        bubbles: true,
      });

      selectElement.dispatchEvent(event);
    },
    handleChange(event) {
      this.$emit('update:value', event.target.value);
    },
  },
};
</script>
